import { useRoutes } from 'react-router-dom';
import router from 'src/router';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import store from './store';

function App() {
  const content = useRoutes(router);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <CssBaseline />
        {content}
      </ThemeProvider>
    </Provider>
  );
}
export default App;
